import React from 'react';
import * as S from './HobHeaderMmtStyles';
import { HOB_DEST_BACK_ICON, HOB_EDIT_ICON_URL, HOB_INFO_ICON_URL } from '../../../../../../shared/config/constants';

const HobHeaderMmt = ({
  title,
  onIconClick,
  showEditIcon = false,
  showBackIcon = true,
  showInfoIcon = false,
  onEditIconClick = () => {},
  onInfoIconPress = () => { },
  setTooltipRef = () => { },
}) => (
  <S.Container>
    <S.Content>
      {showBackIcon && (
        <div onClick={onIconClick}>
          <S.IconPadding>
            <S.Icon src={HOB_DEST_BACK_ICON} />
          </S.IconPadding>
        </div>
      )}
      <S.ContentWrapper style={{paddingRight: showEditIcon ? 0 : 48}}>
        <S.HeaderTitle title={title}>
          {title}
        </S.HeaderTitle>
        {showInfoIcon && (
          <div onClick={onInfoIconPress}>
            <S.IconPadding>
              <S.InfoIcon
                src={HOB_INFO_ICON_URL}
                ref={(_viewRef) => setTooltipRef(_viewRef)}
              />
            </S.IconPadding>
          </div>
        )}
      </S.ContentWrapper>
      {showEditIcon && (
        <div onClick={onEditIconClick}>
          <S.IconPadding>
            <S.EditIcon src={HOB_EDIT_ICON_URL} />
          </S.IconPadding>
        </div>
      )}
    </S.Content>
  </S.Container>
);

export default HobHeaderMmt